export const roundToDecimal = (value: number | null | undefined): number => {
  if (value === null || value === undefined) {
    return 0;
  }
  return Math.round(value * 10) / 10;
};
